import { render, staticRenderFns } from "./waitDeliverGoods.vue?vue&type=template&id=e57f0f18&scoped=true&"
import script from "./waitDeliverGoods.vue?vue&type=script&lang=js&"
export * from "./waitDeliverGoods.vue?vue&type=script&lang=js&"
import style0 from "./waitDeliverGoods.vue?vue&type=style&index=0&id=e57f0f18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e57f0f18",
  null
  
)

export default component.exports